<template>
  <v-card class="mx-auto mt-4 rounded-card" elevation="4" max-width="800">
    <div class="row justify-content-start">
      <div class="col-9 ml-4">
        <p style="color: #000;" class="title font-weight-bold text-truncate text-wrap">
          {{ this.title }}
        </p>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-calendar</v-icon>
          <label> {{ this.date }} </label>
        </div>
      </div>
      <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-web-clock</v-icon>
          <label> {{ this.time }} </label>
        </div>
      </div>
      <div class="row justify-content-start">
        <v-card-subtitle> address: {{ this.address }} </v-card-subtitle>
      </div>
      <div class="row justify-content-start">
        <v-chip class="ma-2" style="color: white" color="primary">
          {{ this.status }}
        </v-chip>
      </div>

      <p style="color: #000;" class="font-italic text-wrap">phoneNumber: {{ this.phoneNumber }}</p>
    </div>

    <v-card-text class="text-truncate">
      {{ this.body }}
    </v-card-text>
        <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <v-btn @click="show = !show" color="blueblack" text>
            <label>
              {{ show ? "Less" : "More" }}
            </label>
          </v-btn>

          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          {{ this.body }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <v-img v-if="this.image" :src="this.image" height="200px"></v-img>
  </v-card>
</template>

<script>
export default {
    props: ["id", "title", "body", "address", "phoneNumber", "date", "time", "status", "image"],
  data: () => ({
    show: false,
  }),    
};
</script>